import { useEffect, useState } from 'react'
import BestSeller from './BestSeller'
import BrowseCategories from './BrowseCategories'
import OfferBanner from './OfferBanner'
import Footer from '../../Components/Footer'
import { connect, useSelector } from 'react-redux'
import { getBestSellers, getComboDetail, getGroups, getItemDetail, getTopDeals, saveCart } from '../../Redux'
import { API_URL, IMAGE_URL, priceunit } from '../../Components/client-config'
import { Modal } from 'react-bootstrap'
import MenuBox from './MenuBox'
import TopDeals from './TopDeals'
import Pickuo from "../../Assetes/Images/pickup-banner.jpg"
import favorits from "../../Assetes/Images/favorites-banner.png"
import appImg from "../../Assetes/Images/banners/downloadApp.jpg"
import kfcbasket from "../../Assetes/Images/kfc-basket2.svg"
import { Link, useHistory } from 'react-router-dom'
import ComboMenuBox from './ComboMenuBox'
import { toast } from 'react-toastify'
import _ from 'lodash'
import Header from '../../Components/Header'
import MobileCategories from './MobileCategories'
import SelectStoreModal from '../../Components/selectStoreModal'
import { Helmet } from 'react-helmet'
import KfcMeal from "../../Assetes/Images/explore_new.jpg"
import axios from 'axios'
import JazzCashOnly from '../../Components/JazzCashOnly'
import SuggestiveProducts from './SuggestiveProducts'
import getDeviceStoreLink from '../../utils/deviceType'
import useCurrentLocale from '../../hooks/useLanguage'
import { useTranslation } from 'react-i18next'
import React from 'react'
import { COUNTRY_NAME, ORDER_CHANNELS } from '../../lib'
var CryptoJS = require("crypto-js");


function MenuPage(props: any) {
  const [show, setShow] = useState(false);
  const [comboOpen, setComboOpen] = useState(false);
  const [headerUpdate, setHeaderUpdate] = useState(0);
  const [selectStoreShow, setSelectStoreModal] = useState(false);
  const comboData = useSelector((state: any) => state.menu.comboData);
  const itemData = useSelector((state: any) => state.menu.itemData);
  const [showBanner, showPopupBanner] = useState(false);
  const [popupBanners, setPopupBanners] = useState([]);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleComboClose = () => setComboOpen(false);
  const handleComboOpen = () => setComboOpen(true);
  const handleSelectStoreClose = () => setSelectStoreModal(false);
  const [selectJCShow, setSelectJCModal] = useState(false);
  const isLogged = useSelector((state: any) => state.customer.isLogged);
  const [ModalType, setModalType] = useState('');
  const [showSuggDeal, setShowSuggestiveDeal] = useState(false);
  const [topDealData, setTopDealData]: any = useState(null)
  const [showSuggDealOutSide, setShowSuggDealOutSide] = useState(false);
  const lang = useCurrentLocale();

  const [title, setTitle] = useState(`KFC ${COUNTRY_NAME} | Deals & Offers`);
  const [meta, setMeta] = useState("Kentucky Fried Chicken provides the best, the most scrumptiously crispy fried chicken and zinger burgers that will leave your mouth watering for more")

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const groups = useSelector((state: any) => state.menu.homeGroups);
  const topDeals = useSelector((state: any) => state.menu.topDeals);
  const bestSellers = useSelector((state: any) => state.menu.bestSellers);
  let cartData = useSelector((state: any) => state.cart.cartData)
  const storeSelected = useSelector((state: any) => state.store.storeSelected);
  const couponDetails = useSelector((state: any) => state.menu.couponDetails);
  const orderType = useSelector((state: any) => state.payment.orderType);
  useEffect(() => {
    const data: any = {
      mode: "online",
      store_id: storeSelected ? storeSelected.store_id : null
    }
    props.getGroups(data)
    let body: any = {
      mode: "online",
      channel: orderType ? orderType : null,
      store_id: storeSelected ? storeSelected.store_id : null
    }
    props.getTopDeals(body)
    props.getBestSellers(body)
    let popupBanner = sessionStorage.getItem("popup")
    if (!popupBanner) {
      let body: any = {
        banner_type: "popup",
        store_id: storeSelected ? storeSelected.store_id : null
      }
      let encryptedData: any = CryptoJS.AES.encrypt(JSON.stringify(body), process.env.REACT_APP_EncryptionKey).toString();
      axios.post(`${API_URL}menu/banners`, { body: encryptedData }).then(async (response) => {
        if (response.data.success) {
          if (response.data.successResponse && response.data.successResponse.length > 0) {
            setPopupBanners(response.data.successResponse)
            showPopupBanner(true)
            sessionStorage.setItem("popup", "true")
          }
        } else {
          showPopupBanner(false)
        }
      }).catch((err: any) => {
        showPopupBanner(false)
      })
    }
  }, [])
  const handleSelectJSToogle = () => {
    if (ModalType === 'item' && itemData.item_size && itemData.item_size[0].is_jazz_cash === 1) {
      setSelectJCModal((prev) => {
        return !prev
      })
    }
    if (ModalType === 'combos' && comboData && comboData.is_jazz_cash && comboData.is_jazz_cash == 1) {
      setSelectJCModal((prev) => {
        return !prev
      })
    }
  }
  const selectedItem = (item: any) => {
    setModalType(item.sync_type)
    let orderTypeDetail: any = orderType ? orderType : null;
    // for banner
    if (item.sync_type_id) {
      if (item.sync_type_id && item.sync_type_id.combo_id > 0) {
        props.getComboDetail(orderTypeDetail, item.sync_type_id.combo_id, handleComboOpen)
        let products: any = []
        let MapObj: any = {}
        MapObj = {
          combo_id: item.sync_type_id.combo_id
        }
        products.push(MapObj)
        let windowObj = (window as any)
        windowObj.dataLayer.push({ ecommerce: null });
        windowObj.dataLayer.push({
          'event': 'topBanner',
          'ecommerce': {
            'currencyCode': 'PKR',
            'add': {                       // 'add' actionFieldObject measures.
              'products': products
            }
          }
        });
      } else if (item.sync_type_id && item.sync_type_id.menu_item_id > 0) {
        props.getItemDetail(orderTypeDetail, item.sync_type_id.menu_item_id, handleShow)
        let products: any = []
        let MapObj: any = {}
        MapObj = {
          item_id: item.sync_type_id.menu_item_id
        }
        products.push(MapObj)
        let windowObj = (window as any)
        windowObj.dataLayer.push({ ecommerce: null });
        windowObj.dataLayer.push({
          'event': 'topBanner',
          'ecommerce': {
            'currencyCode': 'PKR',
            'add': {                       // 'add' actionFieldObject measures.
              'products': products
            }
          }
        });
      }
      setTitle(item.sync_type_id.meta_title)
      setMeta(item.sync_type_id.meta_description)
    } else {
      setTitle(item.meta_title)
      setMeta(item.meta_description)
    }
    // End for banner
    // For topDeals and BestSellers
    if (item.menu_item_id && item.menu_item_id > 0) {
      props.getItemDetail(orderTypeDetail, item.menu_item_id, handleShow)
    }
    if (item.combo_id && item.combo_id > 0) {
      props.getComboDetail(orderTypeDetail, item.combo_id, handleComboOpen)
    }
    //End For topDeals and BestSellers
    let products: any = []
    let MapObj: any = {}
    showPopupBanner(false)
    if (item.menu_item_id && item.menu_item_id > 0) {
      MapObj = {
        price: item.item_size && priceunit + item.item_size[0].mrp,
        id: item.menu_item_id,
        name: item.item_name,

      }
    }
    else if (item.combo_id && item.combo_id > 0) {
      MapObj = {
        price: item.combo_mrp_price,
        id: item.combo_id,
        name: item.item_name,
      }
    }
    products.push(MapObj)
    let windowObj = (window as any)
    windowObj.dataLayer.push({ ecommerce: null });
    windowObj.dataLayer.push({
      'event': 'view_item',
      'ecommerce': {
        'currencyCode': 'PKR',
        'checkout': {
          'actionField': { 'step': 'Location', 'option': 'Cash' },
          'products': products
        }
      }
    });
  }
  const CloseCompoment = () => {
    handleClose()
    handleComboClose()
    setTitle(`KFC ${COUNTRY_NAME} | Deals & Offers`)
    setMeta("Kentucky Fried Chicken provides the best, the most scrumptiously crispy fried chicken and zinger burgers that will leave your mouth watering for more")
    if (window.location.hash) {
      window.history.replaceState("", document.title, window.location.pathname);
    }
  }
  const history = useHistory();
  const handleFavourite = () => {
    let token = localStorage.getItem("userToken");
    if (!isLogged) {
      toast.info(t("PLEASE_LOGIN_FIRST_TO_VIEW_FAVOURITE_LIST"))
    }
    else {
      history.push(`/${lang}/your-favourites-items`);
    }
  }
  function addtoCart(item: any) {
    let whatProduct = item.item_size && item.item_size.length > 0 ? 'item' : 'combo';

    let initialPrice = Number(
      item.item_size && item.item_size.length > 0 ?
        (item.item_size[0].discount_price !== null &&
          item.item_size[0].discount_price !== undefined &&
          item.item_size[0].discount_price < item.item_size[0].mrp &&
          (item.item_size[0].order_channel == ORDER_CHANNELS.ONLINE || item.item_size[0].order_channel == ORDER_CHANNELS.ALL)) ?
          item.item_size[0].discount_price
          :
          item.item_size[0].mrp
        :
        (item.discount_price !== null &&
          item.discount_price !== undefined &&
          item.discount_price < item.combo_mrp_price &&
          (item.order_channel == ORDER_CHANNELS.ONLINE || item.order_channel == ORDER_CHANNELS.ALL)) ?
          item.discount_price
          :
          item.combo_mrp_price
    );
    let itemPrice = Number(
      item.item_size && item.item_size.length > 0 ?
        (item.item_size[0].discount_price !== null &&
          item.item_size[0].discount_price !== undefined &&
          item.item_size[0].discount_price < item.item_size[0].mrp &&
          (item.item_size[0].order_channel == ORDER_CHANNELS.ONLINE || item.item_size[0].order_channel == ORDER_CHANNELS.ALL)) ?
          item.item_size[0].discount_price
          :
          item.item_size[0].mrp
        :
        (item.discount_price !== null &&
          item.discount_price !== undefined &&
          item.discount_price < item.combo_mrp_price &&
          (item.order_channel == ORDER_CHANNELS.ONLINE || item.order_channel == ORDER_CHANNELS.ALL)) ?
          item.discount_price
          :
          item.combo_mrp_price
    );

    let cart: any = cartData;

    if (!_.isEmpty(cart)) {

      let found = false;

      cart.forEach((element: any) => {
        if (element["combo"]) {
          if (element["combo"].combo_id == item.combo_id) {
            element.quantity = element.quantity + 1;
            const hasDiscountForExisting = item.discount_price !== null &&
              item.discount_price !== undefined &&
              item.discount_price < item.combo_mrp_price &&
              (item.order_channel == ORDER_CHANNELS.ONLINE || item.order_channel == ORDER_CHANNELS.ALL);
            let itemNetPrice = hasDiscountForExisting ? Number(item.discount_price) : Number(item.combo_mrp_price);
            element.totalItemPrice = itemNetPrice + element.totalItemPrice;
            found = true
          }
        }
        else if ((element["selectedsize"])) {
          if (element["selectedsize"].id == item.menu_item_id) {
            element.quantity = element.quantity + 1;
            const hasDiscountForExisting = item.item_size[0].discount_price !== null &&
              item.item_size[0].discount_price !== undefined &&
              item.item_size[0].discount_price < item.item_size[0].mrp &&
              (item.item_size[0].order_channel == ORDER_CHANNELS.ONLINE || item.item_size[0].order_channel == ORDER_CHANNELS.ALL);
            let itemNetPrice = hasDiscountForExisting ? Number(item.item_size[0].discount_price) : Number(item.item_size[0].mrp);
            element.totalItemPrice = itemNetPrice + element.totalItemPrice;
            found = true
          }
        }
      })

      if (!found) {
        console.log('not found: ', item)
        const itemcart = {
          [whatProduct]: item,
          quantity: 1,
          price: Number(initialPrice),
          totalItemPrice: Number(itemPrice),
          modifiers: item.modifiers,
          collapseIn: false
        };

        if (whatProduct == 'combo') {
          itemcart['modifiers'] = item.modifiers;
        }

        if (whatProduct == 'item') {
          itemcart['selectedsize'] = item.item_size[0];
        }

        cart.push(itemcart);
      }
    }
    else {
      const itemcart = {
        [whatProduct]: item,
        quantity: 1,
        price: Number(initialPrice),
        totalItemPrice: Number(itemPrice),
        modifiers: item.modifiers,
        collapseIn: false
      };

      if (whatProduct == 'combo') {
        itemcart['modifiers'] = item.modifiers;
      }

      if (whatProduct == 'item') {
        itemcart['selectedsize'] = item.item_size[0];
      }

      cart.push(itemcart);
    }

    props.saveCart(cart);

    let windowObj = (window as any)
    windowObj.dataLayer.push({ ecommerce: null });
    windowObj.dataLayer.push({
      'event': 'add_to_cart',
      'ecommerce': {
        currency: 'PKR',
        value: Number(itemPrice),
        items: [
          {
            item_id: whatProduct == 'item' ? item.menu_item_id : item.combo_id,
            item_name: whatProduct == 'item' ? item.item_name : item.combo_name,
            price: Number(initialPrice),
            quantity: 1,
            item_category: item?.group_id?.group_name || item?.item_group_id?.group_name,
            discount: whatProduct == 'item' ? item?.item_size[0]?.discount_value : item?.discount_value ? item.discount_value : 0
          }
        ]
      }
    });

    if (storeSelected) {
      if (item.combo_id > 0) { // because it's for only topDeals, bestSeller add to cart button is only on staging not on production
        if (!_.isEmpty(storeSelected) && setShowSuggDealOutSide) {
          if (item.child_products && item.child_products.length > 0) {
            item.child_products.forEach((obj: any) => {
              if (obj.is_lsm == 1 && obj.is_active == 1) {
                return storeSelected && obj.itemStores.length > 0 && obj.itemStores.map((obj2: any) => {
                  if ((obj2.store_id.store_id == storeSelected.store_id) && obj.is_active == 1) {
                    setTimeout(() => {
                      setShowSuggDealOutSide(true)
                    }, 500)
                  }
                })
              } else if (obj.is_lsm == 0 && obj.is_active == 1) {
                setTimeout(() => {
                  setShowSuggDealOutSide(true)
                }, 500)
              } else if (obj.is_lsm === 2 && obj.is_active == 1) {
                let exist = false;
                let timeoutSet = false;

                obj.itemStores.forEach((obj2: any) => {
                  if (obj2.store_id.store_id == storeSelected.store_id && obj.is_active === 1) {
                    exist = true;
                  }
                });
                if (!exist && !timeoutSet) {
                  setTimeout(() => {
                    setShowSuggDealOutSide(true);
                  }, 500);
                  timeoutSet = true;
                }
                return null;
              }
            })
          }
        }
      }
      setHeaderUpdate(headerUpdate + 1)
      toast.success(`${item.combo_name ? item.combo_name : item.item_name} ${t("ADDED_TO_CART")}`, {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 3000
      });
    }

  }
  function handleAdd(item: any) {
    const hasDiscount = item.menu_item_id > 0
      ? (item.item_size?.[0]?.discount_price !== null &&
        item.item_size?.[0]?.discount_price !== undefined &&
        item.item_size[0].discount_price < item.item_size[0].mrp)
      : (item.discount_price !== null &&
        item.discount_price !== undefined &&
        item.discount_price < item.combo_mrp_price);
    if (couponDetails && hasDiscount) {
      toast.error(`This item has a discount and cannot be added while a coupon is applied. Please remove the coupon first.`, {
        position: toast.POSITION.TOP_RIGHT,
        hideProgressBar: true,
        autoClose: 3000,
      });
      return;
    }
    let channel = orderType;
    let obj: any = {
      mode: 'online'
    }
    var encryptedData = CryptoJS.AES.encrypt(JSON.stringify(obj), process.env.REACT_APP_EncryptionKey).toString();
    if (_.isEmpty(storeSelected)) {
      setSelectStoreModal(true)
    }
    if (item.menu_item_id > 0) {
      axios.post(`${API_URL}menu/item/${item.menu_item_id}`, { body: encryptedData }).then((response: any) => {
        if (response.data.success) {
          let itemData = response.data.successResponse;
          if (channel) {
            if (channel == "Delivery") {
              if (itemData.item_channel_id == 1 || itemData.item_channel_id == 5) {
                addtoCart(item)
              } else {
                toast.info(t("PRODUCT_ONLY_PICKUP"), {
                  position: toast.POSITION.TOP_RIGHT,
                  hideProgressBar: true,
                  autoClose: 3000,
                });
              }
            } else if (channel == "Pickup") {
              if (itemData.item_channel_id == 2 || itemData.item_channel_id == 5) {
                addtoCart(item)
              } else {
                toast.info(t("ONLY_DELIVERY_AVAILABLE"), {
                  position: toast.POSITION.TOP_RIGHT,
                  hideProgressBar: true,
                  autoClose: 3000,
                });
              }
            }
          } else {
            if (itemData.item_channel_id == 5) {
              addtoCart(item)
            } else {
              toast.info(t("PRODUCT_NOT_AVAILABLE"), {
                position: toast.POSITION.TOP_RIGHT,
                hideProgressBar: true,
                autoClose: 3000,
              });
            }
          }
        }
      }).catch(err => {
        toast.info(t("PRODUCT_NOT_AVAILABLE"), {
          position: toast.POSITION.TOP_RIGHT,
          hideProgressBar: true,
          autoClose: 3000,
        });
      })
    } else {
      setTopDealData(item)
      axios.post(`${API_URL}menu/combo/${item.combo_id}`, { body: encryptedData }).then((response: any) => {
        if (response.data.success) {
          let comboData = response.data.successResponse;
          if (channel) {
            if (channel == "Delivery") {
              if (comboData.combo_channel_id == 1 || comboData.combo_channel_id == 5) {
                addtoCart(item)
              } else {
                toast.info(t("PRODUCT_ONLY_PICKUP"), {
                  position: toast.POSITION.TOP_RIGHT,
                  hideProgressBar: true,
                  autoClose: 3000,
                });
              }
            } else if (channel == "Pickup") {
              if (comboData.combo_channel_id == 2 || comboData.combo_channel_id == 5) {
                addtoCart(item)
              } else {
                toast.info(t("ONLY_DELIVERY_AVAILABLE"), {
                  position: toast.POSITION.TOP_RIGHT,
                  hideProgressBar: true,
                  autoClose: 3000,
                });
              }
            }
          } else {
            if (comboData.combo_channel_id == 5) {
              addtoCart(item)
            } else {
              toast.info(t("PRODUCT_NOT_AVAILABLE"), {
                position: toast.POSITION.TOP_RIGHT,
                hideProgressBar: true,
                autoClose: 3000,
              });
            }
          }
        }
      }).catch(err => {
        toast.info(t("PRODUCT_NOT_AVAILABLE"), {
          position: toast.POSITION.TOP_RIGHT,
          hideProgressBar: true,
          autoClose: 3000,
        });
      })
    }
  };
  const closeSuggCompoment = () => {
    setShowSuggDealOutSide(false)
    setShowSuggestiveDeal(false)
    setTopDealData(null)
  }
  // To false of showSuggDeal in the case of 0 suggestive products show because setShowSuggestiveDeal
  // is calling only on selected item function of suggestive products component
  useEffect(() => {
    {
      (!_.isEmpty(comboData) && comboData.child_products && comboData.child_products.length > 0) && comboData.child_products
        .map((obj: any) => {
          obj.suggestive_child_products.length > 0 && obj.suggestive_child_products.filter((childProduct: any) => {
            return childProduct.suggestive_combo_id ? (!cartData.some((obj: any) => obj.combo && obj.combo.combo_id == childProduct.suggestive_combo_id.combo_id) && childProduct.suggestive_combo_id.is_suggestive == 1) : (!cartData.some((obj: any) => obj.item && obj.item.menu_item_id == childProduct.suggestive_item_id.menu_item_id) && childProduct.suggestive_item_id.is_suggestive == 1)
          }).length == 0 && setShowSuggestiveDeal(false);
        })
    }
    {
      (!_.isEmpty(itemData) && itemData.child_products && itemData.child_products.length > 0) && itemData.child_products
        .map((obj: any) => {
          obj.suggestive_child_products.length > 0 && obj.suggestive_child_products.filter((childProduct: any) => {
            return childProduct.suggestive_combo_id ? (!cartData.some((obj: any) => obj.combo && obj.combo.combo_id == childProduct.suggestive_combo_id.combo_id) && childProduct.suggestive_combo_id.is_suggestive == 1) : (!cartData.some((obj: any) => obj.item && obj.item.menu_item_id == childProduct.suggestive_item_id.menu_item_id) && childProduct.suggestive_item_id.is_suggestive == 1)
          }).length == 0 && setShowSuggestiveDeal(false);
        })
    }
    {
      (!_.isEmpty(topDealData) && topDealData.child_products && topDealData.child_products.length > 0) && topDealData.child_products
        .map((obj: any) => {
          obj.suggestive_child_products.length > 0 && obj.suggestive_child_products.filter((childProduct: any) => {
            return childProduct.suggestive_combo_id ? (!cartData.some((obj: any) => obj.combo && obj.combo.combo_id == childProduct.suggestive_combo_id.combo_id) && childProduct.suggestive_combo_id.is_suggestive == 1) : (!cartData.some((obj: any) => obj.item && obj.item.menu_item_id == childProduct.suggestive_item_id.menu_item_id) && childProduct.suggestive_item_id.is_suggestive == 1)
          }).length == 0 && setShowSuggDealOutSide(false);
        })
    }
  }, [itemData, comboData, topDealData, showSuggDeal, showSuggDealOutSide]);

  const { t } = useTranslation();
  return (
    <>
      {/* meta Tage */}
      <Helmet>
        <meta name="description" content={meta} />
        <title>{title}</title>
      </Helmet>

      <div className='mt-100'>
        <Header headerUpdate={headerUpdate} />
        <OfferBanner selectedItem={selectedItem} />
        <div className='b-card-web'>
          <BrowseCategories groups={groups} />
        </div>
        <div className='b-card-mob'>
          <MobileCategories groups={groups} />
        </div>
        <BestSeller bestSellers={bestSellers} selectedItem={selectedItem} />
        <TopDeals topDeals={topDeals} selectedItem={selectedItem} handleAdd={handleAdd} />
        <div className='container'>
          <div className="row">
            <div className="col-md-6 mt-4">
              <Link to={`/${lang}/menu`}>
                <img className='w-100 img-border' src={Pickuo} alt="" />
              </Link>
            </div>
            <div className="col-md-6 mt-4">
              <img className='w-100 img-border' onClick={handleFavourite} src={favorits} alt="" />
            </div>
          </div>
        </div>
        <div className='container'>
          <div className="row">
            <div className="col-md-6 mt-4">
              <a href={getDeviceStoreLink()} target="_blank"><img className='w-100 img-border' src={appImg} alt="" /></a>
            </div>
            <div className="col-md-6 mt-4">
              <div className='kfc-basket'>
                <img src={KfcMeal} alt="KfcMeal" />
                <h5>{t("ADDING11HERBSANDSPICES")}</h5>
                <Link to={`/${lang}/menu`}><button>{t("EXPLOREMENU")}</button></Link>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        {show &&
          <Modal show={show} onHide={CloseCompoment} backdrop="static" keyboard={false} size="lg" centered>
            <div className='modal-design'>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <Modal.Header className='p-0 border-0' closeButton />
            <MenuBox setShowSuggestiveDeal={setShowSuggestiveDeal} handleClose={CloseCompoment} setSelectStoreModal={setSelectStoreModal} handleToogle={handleSelectJSToogle} />
          </Modal>
        }
        {comboOpen &&
          <Modal show={comboOpen} onHide={CloseCompoment} backdrop="static" keyboard={false} size="lg" centered>
            <div className='modal-design'>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <Modal.Header className='p-0 border-0' closeButton />
            <ComboMenuBox setShowSuggestiveDeal={setShowSuggestiveDeal} handleClose={CloseCompoment} setSelectStoreModal={setSelectStoreModal} handleToogle={handleSelectJSToogle} />
          </Modal>
        }
        <Modal className='offer-popup offer-popup-modal' style={{ cursor: "pointer" }} backdrop="static" keyboard={false} show={showBanner} onHide={() => { showPopupBanner(false) }} centered>
          <Modal.Header className='popup-modal-header p-0' closeButton>
          </Modal.Header>
          <Modal.Body className='p-0'>
            {popupBanners && popupBanners.length > 0 ?
              popupBanners.map((item: any) => {
                return <div onClick={() => selectedItem(item)}>
                  <img className='menu-popup-slider w-100' src={`${IMAGE_URL}${item.desktop_image}`} alt="" />
                </div>
              })
              : ""
            }
          </Modal.Body>
        </Modal>
        <SelectStoreModal show={selectStoreShow} handleClose={handleSelectStoreClose} />
        <JazzCashOnly show={selectJCShow} handleToogle={handleSelectJSToogle} />
        {(!_.isEmpty(comboData) && comboData.child_products && comboData.child_products.length > 0) && comboData.child_products
          .map((obj: any) => {
            return obj.suggestive_child_products.length > 0 && obj.suggestive_child_products.filter((childProduct: any) => {
              return childProduct.suggestive_combo_id ? (!cartData.some((obj: any) => obj.combo && obj.combo.combo_id == childProduct.suggestive_combo_id.combo_id) && childProduct.suggestive_combo_id.is_suggestive == 1) : (!cartData.some((obj: any) => obj.item && obj.item.menu_item_id == childProduct.suggestive_item_id.menu_item_id) && childProduct.suggestive_item_id.is_suggestive == 1)
            }).length > 0 && showSuggDeal && <SuggestiveProducts comboData={comboData} itemData={itemData} handleShow={handleShow} handleComboOpen={handleComboOpen} showSuggDeal={showSuggDeal} closeSuggCompoment={closeSuggCompoment} />
          })}
        {(!_.isEmpty(itemData) && itemData.child_products && itemData.child_products.length > 0) && itemData.child_products
          .map((obj: any) => {
            return obj.suggestive_child_products.length > 0 && obj.suggestive_child_products.filter((childProduct: any) => {
              return childProduct.suggestive_combo_id ? (!cartData.some((obj: any) => obj.combo && obj.combo.combo_id == childProduct.suggestive_combo_id.combo_id) && childProduct.suggestive_combo_id.is_suggestive == 1) : (!cartData.some((obj: any) => obj.item && obj.item.menu_item_id == childProduct.suggestive_item_id.menu_item_id) && childProduct.suggestive_item_id.is_suggestive == 1)
            }).length > 0 && showSuggDeal && <SuggestiveProducts comboData={comboData} itemData={itemData} handleShow={handleShow} handleComboOpen={handleComboOpen} showSuggDeal={showSuggDeal} closeSuggCompoment={closeSuggCompoment} />
          })}
        {/* OutSide Add To Cart Button */}
        {(!_.isEmpty(topDealData) && topDealData.child_products && topDealData.child_products.length > 0) && topDealData.child_products
          .map((obj: any) => {
            return obj.suggestive_child_products.length > 0 && obj.suggestive_child_products.filter((childProduct: any) => {
              return childProduct.suggestive_combo_id ? (!cartData.some((obj: any) => obj.combo && obj.combo.combo_id == childProduct.suggestive_combo_id.combo_id) && childProduct.suggestive_combo_id.is_suggestive == 1) : (!cartData.some((obj: any) => obj.item && obj.item.menu_item_id == childProduct.suggestive_item_id.menu_item_id) && childProduct.suggestive_item_id.is_suggestive == 1)
            }).length > 0 && showSuggDealOutSide && <SuggestiveProducts comboData={topDealData} itemData={null} handleShow={handleShow} handleComboOpen={handleComboOpen} showSuggDeal={showSuggDealOutSide} closeSuggCompoment={closeSuggCompoment} />
          })}
      </div>
    </>
  )
}


const mapDispatchToProps = (dispatch: any) => {
  return {
    getGroups: (data: any) => {
      dispatch(getGroups(data))
    },
    getBestSellers: (data: any) => {
      dispatch(getBestSellers(data))
    },
    getTopDeals: (data: any) => {
      dispatch(getTopDeals(data))
    },
    getItemDetail: (orderType: any, id: any, handleShow: any) => {
      dispatch(getItemDetail(orderType, id, handleShow))
    },
    getComboDetail: (orderType: any, id: any, handleComboOpen: any) => {
      dispatch(getComboDetail(orderType, id, handleComboOpen))
    },
    saveCart: (cart: any) => {
      dispatch(saveCart(cart))
    }
  };
};
export default connect(null, mapDispatchToProps)(MenuPage);
